  /**
   * Convert time in seconds to HH:MM:SS
   * 
   * @param  {number} time  Time in seconds
   * @return {string} (HH:)MM:SS
   */
  export default function (time) {
    const hours = Math.floor(time / 3600) % 24;
    const minutes = Math.floor(time / 60) % 60;
    const seconds = Math.floor(time % 60);

    return (hours > 0 ? hours.toString().padStart(2, "0") + ':' : '')
      + minutes.toString().padStart(2, "0") + ':'
      + seconds.toString().padStart(2, "0");
  }
